<template>
  <div>
    <!-- <task-filter @change="onChange" /> -->
    <a-card size="small" :loading="loading">
      <a-card size="small" :loading="loading">
        <template slot="title">
          <span style="margin-right: 4px">表单说明</span>
          <a-popover title="报表说明" placement="topLeft">
            <template slot="content">
              <p>离线表计算有t+1的数据延迟</p>
              <p>缺陷统计范围不包括reject和duplicate状态的缺陷</p>
              <p>统计区间为，缺陷首次处理完成时间在选择时间区间内，且缺陷已经处理完成</p>
              <p>超时计算逻辑为，非生产缺陷p0，p1处理时长超过24h,p2，p3处理时长超过48h；生产缺陷p0，p1处理时长超过24h，生产缺陷p2，p3处理时长超过48h</p>
              <p>p4级缺陷及以下暂不纳入统计范畴</p>
              <p>处理时长为缺陷创建时间～最后一次缺陷修复时间，处理时长过滤非工作时间</p>
            </template>
            <a-icon type="question-circle" />
          </a-popover>
        </template>
        <a-table size="small" :pagination="false" :columns="columns" row-key="index" :data-source="team_data" :loading="loading">
          <span slot="team_name" slot-scope="text, record">{{ record.team_name }} </span>
          <span slot="notDelayPoint" slot-scope="text, record">
            <span>{{ record.total_point - record.delay_point }}</span>
          </span>
          <span slot="delay_point" slot-scope="text, record" @click="onClick(record.id)">{{ record.delay_point }}</span>
          <span slot="delay_one_day_point" slot-scope="text, record" @click="onClick(record.id)">{{ record.delay_one_day_point }}</span>
          <span slot="overtimeRate" slot-scope="text, record">
            <span v-if="record.total_point != 0">{{ (((record.total_point - record.delay_point) / record.total_point) * 100).toFixed(2) }}%</span>
            <span v-else>{{ '0.00%' }}</span>
          </span>
          <span slot="overtimeOneDayRate" slot-scope="text, record">
            <span v-if="record.total_point != 0">{{ (((record.total_point - record.delay_one_day_point) / record.total_point) * 100).toFixed(2) }}%</span>
            <span v-else>{{ '0.00%' }}</span>
          </span>
        </a-table>
      </a-card>
    </a-card>
    <div v-if="taskList && taskList.length > 0">
      <task-delay-modal ref="taskListModal" :task-list="taskList" />
    </div>
  </div>
</template>
<script>
import { getDelayTask } from '@/api/data/task';
import TaskDelayModal from '@/pages/data/components/TaskDelayModal';

const columns = [
  {
    title: '名称',
    dataIndex: 'team_name',
    key: 'team_name',
    width: '10%',
    ellipsis: true,
    scopedSlots: { customRender: 'team_name' }
  },
  {
    title: '总点数',
    dataIndex: 'total_point',
    key: 'total_point',
    width: '15%',
    sorter: (a, b) => a.total_point - b.total_point,
    scopedSlots: { customRender: 'total_point' },
    ellipsis: true
  },
  {
    title: '按时完成点数',
    dataIndex: 'notDelayPoint',
    key: 'notDelayPoint',
    width: '15%',
    sorter: (a, b) => a.notDelayPoint - b.notDelayPoint,
    scopedSlots: { customRender: 'notDelayPoint' },
    ellipsis: true
  },
  {
    title: '按时完成率',
    dataIndex: 'overtimeRate',
    key: 'overtimeRate',
    width: '15%',
    sorter: (a, b) => a.overtime - b.overtime,
    scopedSlots: { customRender: 'overtimeRate' },
    ellipsis: true
  },
  {
    title: '超时完成点数',
    dataIndex: 'delay_point',
    key: 'delay_point',
    sorter: (a, b) => a.delay_point - b.delay_point,
    scopedSlots: { customRender: 'delay_point' },
    width: '15%',
    ellipsis: true
  },
  {
    title: '按时完成率(T+1)',
    dataIndex: 'overtimeOneDayRate',
    key: 'overtimeOneDayRate',
    width: '15%',
    sorter: (a, b) => a.overtime - b.overtime,
    scopedSlots: { customRender: 'overtimeOneDayRate' },
    ellipsis: true
  },
  {
    title: '超时完成点数(T+1)',
    dataIndex: 'delay_one_day_point',
    key: 'delay_one_day_point',
    sorter: (a, b) => a.delay_one_day_point - b.delay_one_day_point,
    scopedSlots: { customRender: 'delay_one_day_point' },
    width: '15%',
    ellipsis: true
  }
];
export default {
  components: { TaskDelayModal },
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns,
      loading: false,
      visible: false,
      activeKey: '1',
      issueList: [],
      taskData: {},
      taskList: [],
      create_begin_time: '',
      create_end_time: '',
      timeList: [],
      data: {
        title: null,
        projects: [],
        start_date: null,
        end_date: null,
        description: null,
        params: {}
      },
      formData: {},
      team_data: [],
      correctionData: []
    };
  },
  watch: {
    filterForm() {
      // console.log(this.filterForm);
      this.getDiagramData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  created() {
    this.getDiagramData();
  },

  methods: {
    onClick(source_id) {
      this.team_data.forEach(item => {
        if (item.id === source_id) {
          this.taskList = item.delay_task_list;
        }
      });
      // this.index = index;
      setTimeout(() => {
        this.$refs.taskListModal.open();
      }, 10); // 延迟 200 毫秒
    },
    getDiagramData() {
      this.loading = true;
      getDelayTask({ ...this.filterForm })
        .then(res => {
          this.team_data = res.data.items;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-tbody > tr > td > p {
  padding: 8px;
  border-bottom: 1px solid #e8e8e8;
  line-height: 20px;
  margin: 0 -8px;
}

/deep/ .ant-table-tbody > tr > td > p:last-child {
  margin-bottom: -12px;
  border: 0;
}

/deep/ .ant-table-tbody > tr > td > p:first-child {
  margin-top: -8px;
}
/deep/.ant-page-header {
  padding: 0;
}

/deep/.ant-tabs-bar {
  margin: 0 0 12px 0;
}
</style>
